export const ACCESSOIRES_GROUPS = ['EN310', 'EN320', 'EN330', 'EN340', 'EA310', 'EA320', 'EA330', 'EA340'];
